import {ref, computed} from 'vue';

import {useContextStore} from '@/stores/contextStore';
import avaPlatformApi from '@/apis/avaPlatform/avaPlatformApi';
import AvaRecorder from '@/commons/avaRecorder';

export const useAvaRecording = proxy => {
  let recording = ref(false);
  let recorder = ref(null);
  let mediaStreamSource = ref(null);
  let streamAudio = ref(null);
  /**
   * xử lý nhập liệu bằng giọng nói
   * nhhoang1 13.05.2024
   */
  const clickRecordTyping = () => {
    const me = proxy;

    me.recording = !me.recording;

    clearTimeout(me.blurTimeout);

    if (me.recording) {
      // check xem có quyền không
      me.$ms.commonFn.checkPermissionMicrophone(startRecording, startRecording, () => {
        me.recording = false;
        me.focused = false;

        // Validate nghiệp vụ
        me.validate();
      });
    } else {
      me.focused = false;

      // stop recording
      stopRecording();

      // Validate nghiệp vụ
      me.validate();
    }
  };

  /**
   * Xử lý record audio
   * nhhoang1 13.05.2024
   */
  async function startRecording() {
    navigator.mediaDevices
      .getUserMedia({audio: true, video: false})
      .then(stream => {
        var AudioContext = window.AudioContext || window.webkitAudioContext;
        let audioContext = new AudioContext();
        streamAudio.value = stream;
        /* use the stream */
        let mediaStream = audioContext.createMediaStreamSource(stream);

        proxy.mediaStreamSource = mediaStream;

        proxy.recorder = new AvaRecorder(
          mediaStream,
          {numChannels: 1},
          async audioBlob => await proxy.getTextFromVoice(audioBlob, true, proxy),
        );

        proxy.recorder.record();
      })
      .catch(error => {
        proxy.recording = false;
        proxy.focused = false;

        console.error('Lỗi khi truy cập microphone: ', error);
      });
  }

  /**
   * Xử lý record audio
   * @param {*} $this
   * @param {*} callbackFn
   * nhhoang1 13.05.2024
   */
  async function stopRecording() {
    proxy.recorder.stop();
    streamAudio.value.getAudioTracks()[0].stop();

    //create the wav blob and pass it on to createDownloadLink
    //đẩy this vào để dùng biến this trong hàm createDownloadLink
    proxy.recorder.exportWAV(blob => proxy.getTextFromVoice(blob, false, proxy));
  }

  /**
   * Lấy thông tin text từ giọng nói
   * nhhoang1 14.05.2024
   */
  async function getTextFromVoice(audioBlob, isGetWavSilent, $this) {
    $this.recorder.isGetWav = true;

    let formData = new FormData();

    formData.append('file', audioBlob, 'recording.wav');

    const context = useContextStore();

    let avaConnectInfoStr = context.$state.context.AVAConnectInfo ? context.$state.context.AVAConnectInfo : null;

    let subScriberNo =
      context.$state.context && context.$state.context.Context && context.$state.context.Context.SubscriberNo
        ? context.$state.context.Context.SubscriberNo
        : '';

    let avaConnectInfo = JSON.parse(avaConnectInfoStr);

    if (!avaConnectInfo || !avaConnectInfo.token) {
      avaConnectInfo = await refreshConnection();
    }

    if (!avaConnectInfo || !avaConnectInfo.token) {
      return;
    }

    formData.append('avaToken', avaConnectInfo.token);
    formData.append('subScriberNo', subScriberNo); // bổ sung thông tin monitor

    try {
      let result = await avaPlatformApi.transferVoice(formData);

      if (result && result.text && typeof $this.setValInput === 'function') {
        $this.setValInput(result.text);

        if (isGetWavSilent) {
          $this.recorder.isGetWavSilent = true;
        }
      }
    } catch (error) {
      console.error(error);
    }

    $this.recorder.isGetWav = false;
  }

  /**
   * Lấy ra thời gian nói
   * nhhoang1 13.05.2024
   */
  const recordingTimeText = computed(() => {
    if (proxy.recorder === null) return '';

    if (proxy.recorder.recordingTime === null) return '';

    const minutes = Math.floor(proxy.recorder.recordingTime / 60);
    const seconds = proxy.recorder.recordingTime % 60;

    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  });

  /**
   * Kết nối AVA
   * @returns
   * nhhoang1 16.05.2024
   */
  const refreshConnection = async () => {
    try {
      let data = await avaPlatformApi.refreshAVAConnect();

      if (data) {
        const contextStore = useContextStore();
        let context = contextStore.$state.context;
        context.AVAConnectInfo = JSON.stringify(data);

        return data;
      }
    } catch (error) {
      console.error(error);
    }

    return null;
  };

  return {
    recording,
    recorder,
    mediaStreamSource,
    recordingTimeText,
    clickRecordTyping,
    getTextFromVoice,
  };
};
